import React from 'react'

export default function Header() {
  return (
    <>
        <div className='power-button-container'>
            <button className='power-button'>Power</button>
        </div>
        <div className='device-name'>
            Power-Serg
        </div>
    </>
  )
}
